class ProductStickyCTA extends HTMLElement {
  mainCTASelector = '.js-product-form__submit';
  _mainCTA = null;

  constructor() {
    super();
    this._boundUpdateVisibility = this._updateVisibility.bind(this);
  }

  connectedCallback() {
    const mainCTASelector =
      this.getAttribute('main-cta-selector') || DEFAULT_MAIN_CTA_SELECTOR;
    this._mainCTA = document.querySelector(mainCTASelector);

    if (!this._mainCTA) return;

    this._updateVisibility();
    window.addEventListener('scroll', this._boundUpdateVisibility, {
      passive: true,
    });

    const stickyButton = this.querySelector('.js-product-sticky-cta__add-to-cart-button');
    if (stickyButton) {
      this._boundHandleButtonClick = () => {
        this._mainCTA.click();
        this._mainCTA.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      stickyButton.addEventListener('click', this._boundHandleButtonClick);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._boundUpdateVisibility);
    const stickyButton = this.querySelector('.js-product-sticky-cta__add-to-cart-button');
    if (stickyButton && this._boundHandleButtonClick) {
      stickyButton.removeEventListener('click', this._boundHandleButtonClick);
    }
  }

  _updateVisibility() {
    const mainCTAInView = this._isMainCTAInView();
    if (mainCTAInView) {
      this.classList.remove('visible');
    } else {
      this.classList.add('visible');
    }
  }
  
  _isMainCTAInView() {
    const rect = this._mainCTA.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    return rect.bottom >= 0 && rect.top <= viewportHeight;
  }
}

if (!customElements.get('product-sticky-cta')) {
  customElements.define('product-sticky-cta', ProductStickyCTA);
}
